var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page page-subscribe"},[_c('ViewSubscriptionOffers',{on:{"select-plan":_vm.Handle_OnSelectPlan,"subscribe":_vm.Handle_OnSubscribe}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }